import React, { useState, useEffect } from 'react';
import { SmartAgent } from '@missionlabs/smartagent-app-components/';
import { Box } from '@missionlabs/smartagent-app-components';
import '../../node_modules/@missionlabs/smartagent-app-components/dist/index.css';
import '../styles/app.scss';

import AppProvider from '../context/Provider';
import Layout from './Layout';

const Main: React.FC<any> = (props) => {
    const [facia, setFacia] = useState("");
    const [token, setToken] = useState("");

    const [sm] = useState<SmartAgent>(props.sm ?? new SmartAgent())

    useEffect(() => {
        setup(sm);
        // eslint-disable-next-line
    }, [sm]);

    const setup = async (sm: SmartAgent) => {
        let contact: any;
        if (props.contact) {
            contact = props.contact;
            sm.init();
        } else {
            contact = await sm!.init();
        }

        console.log("got contact", contact)

        setFacia(contact["sa-facia"] ?? 'jdsportsuk');
        setToken(await sm.getToken())

        console.log(contact['ID'])

        sm.sendMessage('update_quick_connects');

        sm.showPlugin();
    };

    const renderInner = () => {
        if (!facia) return null;

        return (
            <AppProvider facia={facia} token={token} sm={sm}>
                <Layout />
            </AppProvider>
        );
    };

    const isEmbedded = window.parent !== window;
    return isEmbedded ? (
        renderInner()
    ) : (
            <Box alt header="Secure Payment" collapse>
                {renderInner()}
            </Box>
    );
};

export default Main;
